<template>
  <div>
    <!--<base-header></base-header>-->
    <div class="container">
      <form @submit.prevent="verify" class="form-verify">
        <div class="text-center">
          <img src="/static/sendcode.png" />
          <p class="phone-number">{{phone}}</p>
          <p class="text-note mb5">{{$t('register.weHaveSendCode')}}</p>
          <p class="text-note mt0">{{$t('register.pleasedInputCode')}}</p>
        </div>
        <div class="form-group">
          <span class="code-prefix">C - </span>
          <input type="number" pattern="[0-9]*" inputmode="numeric" maxlength="6" class="form-control text-center" v-model="code" placeholder="Mã xác thực" :class="{'form-error': errorMessage['code']}" />
          <p v-for="msg in errorMessage['code']" class="text-error">{{msg}}</p>
        </div>

        <p v-if="resendCode" class="text-center code-resend" @click="resend()">{{$t('register.didntReceived')}}</p>
        <p v-if="!resendCode" class="text-center code-resend disableResend">{{$t('register.didntReceived')}}</p>

        <div class="form-group text-center btn-submit">
          <base-button type="submit" class="btn-block" :disabled="code.length == 0 || isDisabled">{{$t('register.next')}}</base-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Slide from '../components/Slide';
import BaseButton from "../components/Button.vue";
import BaseHeader from "../components/Header.vue";

export default {
  components: {
    BaseHeader,
    BaseButton,
    Slide,
  },
  name: 'VerifyCode',
  props: {
    phone: String,
    token: String,
    resendClick: Boolean
  },
  data() {
    return {
      code: '',
      errorMessage: [],
      isDisabled: false,
      resendCode: true
    };
  },
  methods: {
    verify() {
      this.isDisabled = true;
      this.errorMessage = [];
      const formData = new FormData();
      formData.append('code', this.code);
      formData.append('token', this.token);
      formData.append('phone', this.phone);
      this.axios.post('/verify', formData).then((response) => {
         if ((response.data.status)) {
           this.$router.push({name:'PasswordPage', params: {phone: this.phone, token: this.token}});
         } else {
           this.isDisabled = false;
           this.errorMessage = response.data.data;
           this.resendCode = true;
         }
      })
    },
    resend() {
      this.resendCode = false;
      this.isDisabled = true;
      this.errorMessage = [];
      const formData = new FormData();
      formData.append('token', this.token);
      formData.append('phone', this.phone);
      this.axios.post('/resend', formData).then((response) => {
        if (response.data.status) {
          this.$router.push({name:'VerifyPage', params: {resendClick: false, phone: response.data.data.phone, token: response.data.data.token}});
        } else {
          this.isDisabled = false;
          this.resendCode = true;
        }
      })
    }
  },
  mounted() {
      if(!this.resendClick) {
        this.resendCode = false;
        setTimeout(() => {
          this.resendCode = true;
        }, 60000);
      } else {
        this.resendCode = true;
      }
  }
};
</script>
<style scoped="">
</style>



// WEBPACK FOOTER //
// src/pages/VerifyCode.vue